import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getTokenClaims } from "../auth/auth";

interface RoleGuardProps {
  roles: string[];
  children: ReactNode;
}

const RoleGuard = ({ roles, children }: RoleGuardProps) => {
  const claims = getTokenClaims();
  const hasRole = roles.some((r) => claims?.roles.includes(r));
  return hasRole ? <>{children}</> : <Navigate to="/" replace />;
};

export default RoleGuard;
